import { render, staticRenderFns } from "./product_group_sp.vue?vue&type=template&id=52914a54&scoped=true&"
import script from "./product_group_sp.vue?vue&type=script&lang=js&"
export * from "./product_group_sp.vue?vue&type=script&lang=js&"
import style0 from "./product_group_sp.vue?vue&type=style&index=0&id=52914a54&prod&lang=scss&"
import style1 from "./product_group_sp.vue?vue&type=style&index=1&id=52914a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52914a54",
  null
  
)

export default component.exports